"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TituloTrabalho = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importDefault(require("react"));
var h5_component_1 = require("../../token/heading/h5/h5.component");
var due_date_calendar_1 = require("../due-date-calendar");
var tags_1 = require("../tags");
var styles_1 = require("./styles");
var TituloTrabalho = function (_a) {
    var prazoEntrega = _a.prazoEntrega, titulo = _a.titulo, tags = _a.tags, modoMobile = _a.modoMobile, children = _a.children;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.ContainerTrabalhosHeaderInfoStyledV2, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(due_date_calendar_1.DueDateCalendar, { prazoEntrega: prazoEntrega })),
            react_1.default.createElement("div", { className: "titleSectionWrapper" },
                react_1.default.createElement(h5_component_1.H5, { className: "titleSection" }, titulo),
                !modoMobile && (react_1.default.createElement(styles_1.ContainerTrabalhosHeaderInfoWrapperStyled, null, tags === null || tags === void 0 ? void 0 :
                    tags.map(function (tag, i) { return (react_1.default.createElement("div", { key: i },
                        react_1.default.createElement(tags_1.Tags, { "data-testid": "tag-".concat(tag), color: theme.grey004, className: "trabalhoTag" }, tag))); }),
                    react_1.default.createElement(tags_1.Tags, { color: theme.grey004, className: "trabalhoTag" },
                        "Prazo: ",
                        prazoEntrega !== 'Invalid DateTime' ? prazoEntrega : 'a definir')))),
            react_1.default.createElement(styles_1.ContainerTrabalhosHeaderActionStyled, { className: "acoesWrapper" }, children)),
        modoMobile && (react_1.default.createElement(styles_1.ContainerTrabalhosHeaderInfoWrapperStyled, null, tags === null || tags === void 0 ? void 0 :
            tags.map(function (tag, i) { return (react_1.default.createElement("div", { key: i },
                react_1.default.createElement(tags_1.Tags, { "data-testid": "tag-".concat(tag), color: theme.grey004, className: "trabalhoTag" }, tag))); }),
            react_1.default.createElement(tags_1.Tags, { color: theme.grey004, className: "trabalhoTag" },
                "Prazo: ",
                prazoEntrega !== 'Invalid DateTime' ? prazoEntrega : 'a definir')))));
};
exports.TituloTrabalho = TituloTrabalho;
